/**
 * Constants for dashboard highlight animations and timing
 */

// Animation timing constants for dashboard cloning highlight effect
export const HIGHLIGHT_INITIAL_DISPLAY_TIME = 300; // Time to show teal highlight before starting fade animation (ms)
export const HIGHLIGHT_FADE_CLEANUP_TIME = 1500; // Time to wait before removing animation classes after fade completes (ms)
export const HIGHLIGHT_ANIMATION_DURATION =
  HIGHLIGHT_INITIAL_DISPLAY_TIME + HIGHLIGHT_FADE_CLEANUP_TIME; // Total animation duration (1800ms)
